/**
 * 小工具组合
 */

/**
 * 获取url参数
 * @param  {[type]} name [description]
 * @return {[type]}      [description]
 */
function getQueryString(name) {
    var reg = new RegExp("(^|\\?|&)" + name + "=([^&]*)(\\s|&|$)", "i");
    if (reg.test(location.href)) return unescape(RegExp.$2.replace(/\+/g, " "));
    return "";
}

/**
 * js插入样式表
 * @param  {[type]} style [description]
 * @return {[type]}       [description]
 */
function insertStyle(style){
     var inputcss = document.createElement('style');
     if (typeof inputcss.styleSheet == 'object') {
     	document.getElementsByTagName('head')[0].appendChild(inputcss);
     	inputcss.setAttribute('type', 'text/css');
     	inputcss.styleSheet.cssText = style;
     }
     else{
     	inputcss.innerHTML = style;
     	document.getElementsByTagName('head')[0].appendChild(inputcss);
     }
}

//获取字符串长度，一个中文算2个字符，1个英文算1个字符
function get_length(s) {//返回英文单位
    var char_length = 0;
    for (var i = 0; i < s.length; i++) {
        var son_char = s.charAt(i);
        encodeURI(son_char).length > 2 ? char_length += 1 : char_length += 0.5;
    }
    return char_length;
}
//获取字符串长度，一个中文算1个字符，两个英文算1个字符
function get_length2(s) {//返回中文单位
    var char_length = 0;
    for (var i = 0; i < s.length; i++) {
        var son_char = s.charAt(i);
        encodeURI(son_char).length > 2 ? char_length += 1 : char_length += 0.5;
    }
    if (char_length > parseInt(char_length)) {
        char_length = parseInt(char_length) + 1;
    }
    return char_length;
}
//截取字符串长度，一个中文算2个字符
function cut_str(str, len) {
    var char_length = 0;
    for (var i = 0; i < str.length; i++) {
        var son_str = str.charAt(i);
        encodeURI(son_str).length > 2 ? char_length += 1 : char_length += 0.5;
        if (char_length >= len) {
            var sub_len = char_length == len ? i + 1 : i;
            return str.substr(0, sub_len);
            break;
        }
    }
}

function trim(str) { //删除左右两端的空格
    return str.replace(/(^\s*)|(\s*$)/g, "");
}

module.exports = {
	getQueryString: getQueryString,
	insertStyle: insertStyle,
	get_length: get_length,
	get_length2:get_length2,
	cut_str: cut_str,
    trim:trim
}


//////////////////
// WEBPACK FOOTER
// ./dev/modules/tools/tools.js
// module id = 6
// module chunks = 0 4 5 6 7 8 9 10 12 13 14 15 16 17 19